import { StoreState } from '@/redux/types';
import { getConfigurationErrors } from './getConfigurationErrors';
import { getConfigurationIds } from './getConfigurationIds';

export function getDraftErrorCount(state: StoreState) {
  let count = 0;

  for (const configurationId of getConfigurationIds(state)) {
    const configurationErrors = getConfigurationErrors(state, configurationId);
    if (configurationErrors) {
      count += Object.values(configurationErrors).filter(Boolean).length;
    }
  }

  return count;
}
